import { pickerDateToBackendIso, type IsoDateRange } from '@lib/tz'

type PrimitiveValue = string | number | boolean
type DataValue = PrimitiveValue | PrimitiveValue[]
export type CleanDataObject = Record<string, DataValue>

const toIso = (v: string | Date): string => (v instanceof Date ? pickerDateToBackendIso(v) : v)

/**
 * This function creates a URLSearchParams object from a CleanDataObject
 * It converts arrays to key[] and other values to key
 */
export const createSearchParamsBrackets = (data: CleanDataObject): URLSearchParams => {
  const params = new URLSearchParams()

  Object.entries(data).forEach(([key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value) && ('from' in value || 'to' in value)) {
      const { from, to } = value as { from?: string | Date | null; to?: string | Date | null } & IsoDateRange

      if (from) {
        params.append(`${key}_from`, toIso(from))
      }
      if (to) {
        params.append(`${key}_to`, toIso(to))
      }

      return
    }

    if (Array.isArray(value)) {
      value.forEach((item: PrimitiveValue) => {
        params.append(`${key}[]`, String(item))
      })
    } else if (value !== undefined && value !== null && value !== '' && (!Array.isArray(value) || value.length > 0)) {
      params.append(key, String(value))
    }
  })

  return params
}
